import React from "react";
import { LanguagePicker } from "./LanguagePicker";
import { t } from "../i18n";
const POINTS = [
  { icon: "fa-route", text: "auth.point.routes" },
  { icon: "fa-truck-fast", text: "auth.point.drivers" },
  { icon: "fa-qrcode", text: "auth.point.qr" },
];

/** Split sign-in layout shared by login, registration and password reset - mirrors the merchant app's auth screens. */
export function AuthShell({ eyebrow, title, lead, wide = false, children }) {
  return (
    <div className="auth-shell">
      <aside className="auth-hero">
        <div style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-hero__brand">ODOS</div>
          <div className="eyebrow" style={{ marginTop: 8 }}>{t("auth.portal")}</div>
        </div>
        <div style={{ position: "relative", zIndex: 1 }}>
          <div className="auth-hero__title">{t("auth.hero_title")}</div>
          <div className="auth-hero__copy">{t("auth.hero_copy")}</div>
          <ul className="auth-hero__points">
            {POINTS.map((p) => (
              <li key={p.icon}>
                <i className={`fa-solid ${p.icon}`} aria-hidden="true" />
                {t(p.text)}
              </li>
            ))}
          </ul>
        </div>
        <div className="auth-hero__foot" style={{ position: "relative", zIndex: 1 }}>
          © {new Date().getFullYear()} ODOS · {t("auth.footer")}
        </div>
      </aside>
      <main className="auth-main">
        <div className={`auth-card ${wide ? "auth-card--wide" : ""}`}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
            <LanguagePicker style={{ fontSize: 13 }} />
          </div>
          <div className="auth-mobile-brand">ODOS</div>
          {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
          {title ? <h1>{title}</h1> : null}
          {lead ? <p className="auth-card__lead">{lead}</p> : null}
          {children}
        </div>
      </main>
    </div>
  );
}
